import { Box, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { MainPageContentContainer } from "components/MainPageContentContainer"
import { ChargingRulesPageProvider } from "layouts/charging-rules/context/provider"
import { ChargingRulesContainer, ChargingRulesHeader } from "layouts/charging-rules"
import { OreveFooter } from "components/OreveFooter.tsx"
import { OreveButton } from "components/button/OreveButton.tsx"
import { useChargingRulesContext } from "layouts/charging-rules/context/useChargingRulesContext.ts"
import { Loader } from "components/Loader.tsx"
import { ConnexionError } from "components/ConnexionError.tsx"
import { BackendFeedbackPopup } from "components/popup/BackendFeedbackPopup.tsx"
import RuleIcon from "@mui/icons-material/Rule"
import { transformRulesToBackendSchema } from "layouts/charging-rules/utils/utils.ts"
import { useOrganization } from "context/OrganizationContext"

export const ChargingRulesPage = () => {
    const { organizationId } = useOrganization()

    return (
        <ChargingRulesPageProvider key={organizationId ?? "no-org"}>
            <ChargingRulesPageView />
        </ChargingRulesPageProvider>
    )
}

const ChargingRulesPageView = () => {
    const {
        rules,
        fetchListChargingRules,
        fetchUpdateChargingRules,
        listChargingRulesLoading,
        listChargingRulesSuccess,
        updateChargingRulesStatus,
        updateChargingRuleLoading,
        errorEnergy,
        errorDuration,
        allHoursSelected,
        allDaysSelected,
        noHoursSelected,
        noDaysSelected,
        setIsRuleChanged,
        isRuleChanged,
    } = useChargingRulesContext()

    useEffect(() => {
        fetchListChargingRules()
    }, [])

    const [popup, setPopup] = useState(false)

    const saveAndSendRules = () => {
        const result = transformRulesToBackendSchema(rules)
        fetchUpdateChargingRules(result).then(() => {
            setPopup(true)
            setIsRuleChanged(true)
            fetchListChargingRules()
        })
    }

    if (listChargingRulesLoading && listChargingRulesSuccess == null)
        return (
                <MainPageContentContainer
                    sx={{
                        width: "100%",
                        p: "2.25rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Loader />
                </MainPageContentContainer>
        )

    if (!listChargingRulesSuccess)
        return (
            <MainPageContentContainer
                sx={{
                    p: "2.25rem",
                    display: "flex",
                    justifyContent: "center",
                    gap: "1.5rem",
                }}>
                <ConnexionError />
            </MainPageContentContainer>
        )

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
            }}
        >
            <BackendFeedbackPopup
                open={popup}
                onClose={() => setPopup(false)}
                success={!!updateChargingRulesStatus}
                successTitle="Les règles par défaut ont bien été mises à jour !"
                successContent={
                    <>
                        Vous pouvez modifier les règles à tout moment depuis la page{' '}
                        <Typography variant="bodyLarge" component="span" fontWeight="bold" display="inline">
                            Règles de recharge
                        </Typography>
                    </>
                }
                errorTitle="Une erreur est survenue"
                errorContent="Les règles n'ont pas été enregistrées. Veuillez réessayer ultérieurement."
                buttonText="Revenir aux règles de recharges d'entreprise"
                buttonIcon={RuleIcon}
                dataCy={"nav-charging-rules__popup"}
            />
            <MainPageContentContainer
                sx={{
                    p: "2.25rem",
                }}
            >
                <ChargingRulesHeader />
                <ChargingRulesContainer />
            </MainPageContentContainer>

            <OreveFooter sx={{}}>
                <OreveButton
                    data-cy={"nav-charging-rules__footer--save-change"}
                    type="submit"
                    disabled={
                        isRuleChanged ||
                        errorEnergy ||
                        errorDuration ||
                        allHoursSelected ||
                        allDaysSelected ||
                        noHoursSelected ||
                        noDaysSelected
                    }
                    onClick={saveAndSendRules}
                    variant="contained"
                    color="primary"
                    loading={updateChargingRuleLoading}
                    value="Sauvegarder"
                    style={{
                        position: "sticky",
                        bottom: "2rem",
                        zIndex: 1000,
                    }}
                />
            </OreveFooter>
        </Box>
    )
}
